import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import ModalVideo from 'react-modal-video';
import Breadcrumb from '../../components/Breadcrumb';
import Button from '../../components/Button';

import serviceMainImg from '../../assets/img/service/details-1-1.jpg';
import serviceImg1 from '../../assets/img/service/details-1-2.jpg';
import serviceImg2 from '../../assets/img/service/details-1-3.jpg';
import serviceBg from '../../assets/img/blog/blog-sidebar-6.jpg';

const ServiceDetailsMain = () => {
  const [isOpen, setIsOpen] = useState(false);

  const openModal = () => {
    setIsOpen(!isOpen);
  };

  // Services List
  const services = [
    'Standard dummy text',
    'Lorem ipsum dolor sit amet',
    'Duis aute irure dolor in',
    'Standard dummy text',
    'Lorem ipsum dolor sit amet',
    'Duis aute irure dolor in',
  ];

  return (
    <main>
      <Breadcrumb title="Service Details" subTitle="Services" />

      <div className="it-sv-details__area pt-120 pb-100">
        <ModalVideo
          channel="youtube"
          isOpen={isOpen}
          videoId="PO_fBTkoznc"
          onClose={() => openModal()}
        />
        <div className="container">
          <div className="row">
            <div className="col-xl-9 col-lg-9">
              <div className="it-sv-details__left">
                <div className="it-sv-details__main-thumb mb-35">
                  <img src={serviceMainImg} alt="" />
                </div>
                <h3 className="it-sv-details__title">What is Dental Care?</h3>

                <p className="mb-50">
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed
                  do eiusmod tempor incididunt ut labore et dolore magna aliqua.
                  Ut enim ad minim veniam, quis nostrud exercitation ullamco
                  laboris nisi ut aliquipcommodo consequat. Duis aute irure
                  dolor in reprehenderit in voluptate velit esse cillum dolore
                  eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat
                  non proident, sunt in culpa qui officia deserunt mollit anim
                  id est laborum.
                </p>

                <div className="it-sv-details__notes mt-40 mb-35">
                  <div className="it-sv-details__notes-content grey-bg">
                    <h3 className="h3 it-sv-details__notes-title">
                      “Lorem ipsum dolor sit amet, consectetur adipiscing elit,
                      sed do eiusmod tempor incididunt ut labore et dolore magna
                      aliqua. Ut enim ad minim veniam, quis nostrud”
                    </h3>
                  </div>
                </div>

                <p>
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed
                  do eiusmod tempor incididunt ut labore et dolore magna aliqua.
                  Ut enim ad minim veniam, quis nostrud exercitation ullamco
                  laboris nisi ut aliquipcommodo consequat. Duis aute irure
                  dolor in reprehenderit in voluptate velit esse cillum dolore
                  eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat
                  non proident, sunt in culpa qui officia deserunt mollit anim
                  id est laborum.
                </p>

                <div className="it-sv-details__setup mt-30 mb-10">
                  <div className="row">
                    <div className="col-xl-5 col-md-6">
                      <div className="it-sv-details__setup-box style-1 d-flex align-items-center">
                        <div className="it-sv-details__setup-icon">
                          <i className="flaticon-hospital"></i>
                        </div>
                        <h4 className="it-sv-details__setup-title">
                          Nemo enim ipsam voluptas quia voluptas sit aspernatur
                          aut odit aut fugit
                        </h4>
                      </div>
                    </div>
                    <div className="col-xl-6 col-md-6">
                      <div className="it-sv-details__setup-box style-2 d-flex align-items-center">
                        <div className="it-sv-details__setup-icon">
                          <i className="flaticon-patient"></i>
                        </div>
                        <h4 className="it-sv-details__setup-title">
                          Nemo enim ipsam voluptas quia voluptas sit aspernatur
                          aut odit aut fugit
                        </h4>
                      </div>
                    </div>
                  </div>
                </div>
                <p className="pb-10">
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed
                  do eiusmod tempor incididunt ut labore et dolore magna aliqua.
                  Ut enim ad minim veniam, quis nostrud exercitation ullamco
                  laboris nisi ut aliquipcommodo consequat. Duis aute irure
                  dolor in reprehenderit in voluptate velit esse cillum dolore
                  eu fugiat nulla pariatur
                </p>
                <div className="it-sv-details__content-wrapp">
                  <div className="mb-30">
                    <div className="row align-items-center">
                      <div className="col-xl-7 col-lg-7 col-md-7">
                        <div className="it-sv-details__banner">
                          <img src={serviceImg1} alt="" />
                        </div>
                      </div>
                      <div className="col-xl-5 col-lg-5 col-md-5">
                        <div className="it-sv-details__banner-right">
                          <div className="it-sv-details__banner-text mb-30">
                            <h4 className="it-sv-details__banner-title">
                              Treatments
                            </h4>
                            <p>
                              Health and medical is a category that <br />{' '}
                              encompasses a wide range of topics
                            </p>
                          </div>
                          <div className="it-sv-details__banner-list">
                            <ul>
                              {services.map((service, index) => (
                                <li key={index}>
                                  <i className="fa-regular fa-circle-check"></i>
                                  {service}
                                </li>
                              ))}
                            </ul>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <h4 className="it-sv-details__content-title mb-5">
                    How it works
                  </h4>
                  <p className="pb-15">
                    Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed
                    do eiusmod tempor incididunt ut labore et dolore magna
                    aliqua. Ut enim ad minim veniam, quis nostrud exercitation
                    ullamco laboris nisi ut aliquipcommodo consequat. Duis aute
                    irure dolor in reprehenderit in voluptate velit esse cillum
                    dolore eu fugiat nulla pariatur
                  </p>

                  <div className="it-sv-details__video-thumb mb-35 p-relative">
                    <img className="w-100" src={serviceImg2} alt="" />
                    <Link
                      className="it-choose-play pulse popup-video"
                      to="#"
                      onClick={openModal}
                    >
                      <i className="fa-sharp fa-solid fa-play"></i>
                    </Link>
                  </div>

                  <p>
                    Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed
                    do eiusmod tempor incididunt ut labore et dolore magna
                    aliqua. Ut enim ad minim veniam, quis nostrud exercitation
                    ullamco laboris nisi ut aliquipcommodo consequat. Duis aute
                    irure dolor in reprehenderit in voluptate velit esse cillum
                    dolore eu fugiat nulla pariatur
                  </p>
                </div>
              </div>
            </div>
            <div className="col-xl-3 col-lg-3 mb-50">
              <div className="it-sv-details__right">
                <div className="sidebar-wrap mb-60 p-relative">
                  <div className="sidebar-widget mb-45">
                    <h4 className="sidebar-widget-title mb-35">Search Here</h4>
                    <div className="sidebar-search-box p-relative">
                      <div className="sidebar-search-input">
                        <input type="text" placeholder="Search here" />
                      </div>
                      <div className="sidebar-search-button">
                        <button type="submit">
                          <i className="flaticon-next"></i>
                        </button>
                      </div>
                    </div>
                  </div>
                  <div className="sidebar-widget mb-45">
                    <h4 className="sidebar-widget-title mb-40">
                      Services list
                    </h4>
                    <div className="sidebar-widget-list">
                      <Link to="/blog-details">
                        <i className="flaticon-next"></i>Plastics Surgery
                      </Link>
                      <Link className="active" to="/blog-details">
                        <i className="flaticon-next"></i>Hematology
                      </Link>
                      <Link to="/blog-details">
                        <i className="flaticon-next"></i>Neurology
                      </Link>
                      <Link to="/blog-details">
                        <i className="flaticon-next"></i>Gastrologic
                      </Link>
                      <Link to="/blog-details">
                        <i className="flaticon-next"></i>Orthopedic
                      </Link>
                    </div>
                  </div>
                </div>
                <div
                  className="it-sv-details__contact p-relative"
                  style={{ backgroundImage: `url(${serviceBg})` }}
                >
                  <div className="it-sv-details__contact-content text-center">
                    <div className="it-sv-details__contact-text">
                      <h3>Contact Us</h3>
                    </div>
                    <div className="it-sv-details__contact-text">
                      <span>Enjoy Your Whole Weekend.</span>
                      <Link className="it-btn-theme white-bg" to="/contact">
                        <Button btnText="Get Started Now" />
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>
  );
};

export default ServiceDetailsMain;
